import cls from 'classnames';

import { ForwardModalTab } from '@/forwarding/components/ForwardModal/ForwardModalTab';

import styles from './ForwardModalTabs.module.css';

export interface Tab {
  tab: ForwardModalTab;
  label: string;
}

export interface ForwardModalTabsProps {
  tabs: Tab[];
  currentTab?: ForwardModalTab;
  onTabChange: (tab: ForwardModalTab) => void;
}

function ForwardModalTabs(props: ForwardModalTabsProps) {
  const { tabs, currentTab, onTabChange } = props;

  if (tabs.length <= 1) {
    return null;
  }

  return (
    <div className={styles.tabs}>
      {tabs.map(({ tab, label }) => (
        <button
          key={tab}
          type="button"
          aria-label={label}
          className={cls(styles.tab, { [styles.tabActive]: currentTab === tab })}
          onClick={() => onTabChange(tab)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default ForwardModalTabs;
